import React from 'react';

import { styled } from '@mui/material/styles';

import { usePlateLayoutEditorContext } from 'client/app/components/Parameters/PlateLayout/PlateLayoutEditorProvider';
import { CombinatorialTools } from 'client/app/components/Parameters/PlateLayout/Toolbar/CombinatorialTools';
import { DescriptiveTools } from 'client/app/components/Parameters/PlateLayout/Toolbar/DescriptiveTools';
import { SetupHelperText } from 'client/app/components/Parameters/PlateLayout/Toolbar/SetupHelperText';
import { PlateAssignmentMode } from 'common/types/plateAssignments';

export default function Toolbar() {
  const { isReadonly, plateType, activeSidePanelTab, plateAssignment } =
    usePlateLayoutEditorContext();

  const showActions =
    !isReadonly && activeSidePanelTab === 'liquids' && plateType !== undefined;
  const isCombinatorial =
    plateAssignment.assignmentMode === PlateAssignmentMode.COMBINATORIAL;
  const isDescriptive =
    plateAssignment.assignmentMode === PlateAssignmentMode.DESCRIPTIVE;

  return (
    <Wrapper>
      {!isReadonly && activeSidePanelTab === 'setup' && <SetupHelperText />}
      {showActions && isCombinatorial && <CombinatorialTools />}
      {showActions && isDescriptive && <DescriptiveTools />}
    </Wrapper>
  );
}

const Wrapper = styled('div')(({ theme }) => ({
  gridArea: 'toolbar',
  display: 'flex',
  gap: theme.spacing(4),
  marginBottom: theme.spacing(6),
  minHeight: '30px',
  alignItems: 'center',
}));
